const responseStatusActions = {
    types: {
        RESPONSE_STATUS_SET_LAST_SAVED: 'RESPONSE_STATUS_SET_LAST_SAVED',
        RESPONSE_STATUS_SET_REPLIED_TO: 'RESPONSE_STATUS_SET_REPLIED_TO',
        AUTO_SAVE_FAILED_RESPONSE: 'AUTO_SAVE_FAILED_RESPONSE',
    },

    setLastSaved(contentRevisionId, dateStamp) {
        if (typeof contentRevisionId !== 'number' || typeof dateStamp !== 'string') {
            throw new Error('Incorrect param types.');
        }
        return { type: this.types.RESPONSE_STATUS_SET_LAST_SAVED, contentRevisionId, dateStamp };
    },

    setReplyStatus(contentRevisionId, repliedTo, allDeclarationsRepliedTo) {
        return {
            type: this.types.RESPONSE_STATUS_SET_REPLIED_TO,
            contentRevisionId,
            repliedTo,
            allDeclarationsRepliedTo,
        };
    },

    setAutoSaveFailedResponse(contentRevisionId, autoSaveResponse) {
        return {
            type: this.types.AUTO_SAVE_FAILED_RESPONSE,
            contentRevisionId,
            autoSaveResponse,
        };
    },
};

export default responseStatusActions;
